import { defineComponent as _defineComponent } from 'vue'
import LoadingSpinner from '../loaders/LoadingSpinner.vue'

type StateIcon = {
  normal?: string,
  error?: string,
}

type Props = {
  loading: boolean,
  imgSrc?: string,
  icon: StateIcon,
  errorText?: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RecordedView',
  props: {
    loading: { type: Boolean },
    imgSrc: null,
    icon: null,
    errorText: null
  },
  setup(__props: any) {

const props = __props as {
  loading: boolean,
  imgSrc?: string,
  icon: StateIcon,
  errorText?: string,
};




return { __sfc: true,props, LoadingSpinner }
}

})